import { render } from "./3.ServicesSection.vue?vue&type=template&id=396eb356&scoped=true"
import script from "./3.ServicesSection.vue?vue&type=script&lang=js"
export * from "./3.ServicesSection.vue?vue&type=script&lang=js"

import "./3.ServicesSection.vue?vue&type=style&index=0&id=396eb356&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-396eb356"]])

export default __exports__